export default __webpack_public_path__ + "static/media/sleeptalker-image.5766aa62.png";